import { useEffect, useState } from 'react';

import { Modal, Snackbar } from '@atom/mui';
import api from '@atom/utilities/api';
import { INVENTORY_ASSETS_ENDPOINT } from '@atom/utilities/endpoints';

import InventoryAssetTree from './inventoryAssetTree/InventoryAssetTree';

interface Category {
  id: string;
  name: string;
  categories?: Category[];
}

export interface Props {
  id: string;
  categoryId: string;
  schemaId: string;
  name?: string;
  open?: boolean;
  closeModal?: () => any;
  onComplete?: () => void;
}

const styles = {
  content: {
    height: '50vh',
    padding: 0,
  },
};

const MoveInventoryModal = ({
  id,
  name = '',
  categoryId,
  schemaId,
  open,
  closeModal,
  onComplete,
}: Props) => {
  const [selected, setSelected] = useState<Category>();
  const [loading, setLoading] = useState<boolean>(false);

  const handleToggle = (category: Category) => {
    const isSelected = selected?.id === category.id;
    setSelected(isSelected ? null : category);
  };

  const handleMove = async () => {
    const data = {
      destCategoryId: selected.id,
    };
    setLoading(true);

    try {
      await api.post(`${INVENTORY_ASSETS_ENDPOINT}/${id}/move`, data);

      Snackbar.info({
        message: `Moved ${name} to ${selected.name}`,
      });

      if (closeModal) {
        closeModal();
      }

      if (onComplete) {
        onComplete();
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!open && selected) {
      setSelected(null);
    }
  }, [open]);

  const disabled = !selected || loading;

  return (
    <Modal
      open={open}
      onConfirm={handleMove}
      confirmButtonText="Move"
      onCancel={closeModal}
      title="Move to Folder"
      disabled={disabled}
      contentStyle={styles.content}
      data-cy="moveInventoryModal"
    >
      <InventoryAssetTree
        includeAssets={false}
        schemaIds={[schemaId]}
        selectedCategoryIds={new Set([selected?.id])}
        disabledCategoryIds={new Set([categoryId])}
        onCategoryToggle={handleToggle}
        includeLocationBased
        selectLeafCategory
        dataCyPrefix="moveInventory"
      />
    </Modal>
  );
};

export default MoveInventoryModal;
